import React, { Component } from 'react';
import moment from 'moment';
import { trans } from '../../../../../localization/index';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../../components/Modal/Modal';
import { EnumRejectOrderReason } from '../../../../../constants/enum';

function ItemTypeRejectOrder({ handleRejectOrder, rejectOrderReason }) {
  return (
    <li
      className="item row align-items-center"
      onClick={() => handleRejectOrder(rejectOrderReason.id)}
    >
      <i className={`icon ${rejectOrderReason.icon} col-auto`} />
      <span className="col">{trans(rejectOrderReason.description)}</span>
      <i className="col-auto fas fa-angle-right" />
    </li>
  );
}

class RejectOrderModal extends Component {
  arrayRejectOrderReason = Object.keys(EnumRejectOrderReason)
    .filter(item => {
      const reason = EnumRejectOrderReason[item];
      const { itemDetail } = this.props;
      const { is_asap: isASAP, deliver_time: deliverTime } = itemDetail;

      if (isASAP) {
        return true;
      }

      return moment(deliverTime).isSame(moment(), 'day') ? true : reason.id !== EnumRejectOrderReason.RESTAURANT_BUSY.id;
    })
    .reduce(
    (listItem, item) => {
      const reason = EnumRejectOrderReason[item];

      if (reason.id > 0) {
        return [
          ...listItem,
          {
            id: reason.id,
            description: trans(reason.description),
            icon: reason.icon,
          },
        ];
      }
      return listItem;
    },
    [],
  );
  render() {
    const {
      isOpenDialog,
      handleRejectOrder,
      handleOpenRejectOrder,
    } = this.props;
    return (
      <Modal isOpen={isOpenDialog} width="400px" className="reject-order">
        <ModalHeader>{trans('mod_why_cancel_the_order')}</ModalHeader>
        <ModalBody className="padding-0">
          <ul className="list-reject-reason">
            {this.arrayRejectOrderReason.map(rejectOrderReason => (
              <ItemTypeRejectOrder
                handleRejectOrder={handleRejectOrder}
                rejectOrderReason={rejectOrderReason}
                key={rejectOrderReason.id}
              />
            ))}
          </ul>
        </ModalBody>
        <ModalAction>
          <ModalButton
            type="cancel"
            onClick={() => handleOpenRejectOrder(false)}
          >
            {trans('mod_go_back')}
          </ModalButton>
        </ModalAction>
      </Modal>
    );
  }
}
export default RejectOrderModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/RejectOrder/RejectOrderModal.jsx